/**
 * Homepage hero background slider — autoplay only (no nav buttons or touch swipe).
 */
const TRANSITION_MS = 500;
const DEFAULT_INTERVAL = 5000;
const SELECTORS = {
    root: '[data-hero-slider]',
    slide: '.home-hero__slide',
};
export function initHeroSlider() {
    document.querySelectorAll(SELECTORS.root).forEach((root) => {
        HeroSlider.create(root);
    });
}
class HeroSlider {
    constructor(root) {
        this.currentIndex = 0;
        this.timer = 0;
        this.isAnimating = false;
        this.root = root;
        this.slides = Array.from(root.querySelectorAll(SELECTORS.slide));
        this.animation = root.dataset.heroAnimation === 'slide' ? 'slide' : 'fade';
        this.intervalMs = Math.max(2000, parseInt(root.dataset.heroInterval ?? '', 10) || DEFAULT_INTERVAL);
        if (this.slides.length <= 1) {
            return;
        }
        this.bind();
        this.startAutoplay();
    }
    static create(root) {
        new HeroSlider(root);
    }
    bind() {
        this.root.addEventListener('mouseenter', () => this.stopAutoplay());
        this.root.addEventListener('mouseleave', () => this.startAutoplay());
        this.root.addEventListener('focusin', () => this.stopAutoplay());
        this.root.addEventListener('focusout', (event) => {
            if (!this.root.contains(event.relatedTarget)) {
                this.startAutoplay();
            }
        });
    }
    goTo(index) {
        if (this.isAnimating || this.slides.length <= 1) {
            return;
        }
        const total = this.slides.length;
        const nextIndex = ((index % total) + total) % total;
        if (nextIndex === this.currentIndex) {
            return;
        }
        const currentSlide = this.slides[this.currentIndex];
        const nextSlide = this.slides[nextIndex];
        this.isAnimating = true;
        this.stopAutoplay();
        const animClass = this.animation === 'slide' ? 'slide' : 'fade';
        currentSlide.classList.remove('is-active');
        currentSlide.classList.add(`is-exiting-${animClass}`);
        nextSlide.classList.add(`is-entering-${animClass}`, 'is-active');
        window.setTimeout(() => {
            currentSlide.classList.remove(`is-exiting-${animClass}`);
            nextSlide.classList.remove(`is-entering-${animClass}`);
            this.currentIndex = nextIndex;
            this.isAnimating = false;
            this.startAutoplay();
        }, TRANSITION_MS);
    }
    startAutoplay() {
        this.stopAutoplay();
        if (this.slides.length <= 1) {
            return;
        }
        this.timer = window.setInterval(() => {
            this.goTo(this.currentIndex + 1);
        }, this.intervalMs);
    }
    stopAutoplay() {
        window.clearInterval(this.timer);
    }
}
